/* experimental - could be rewritten to a more general TrackView function simular to dataTrackClick
 This tracks how many times crumbtrails are viewed
 * SOA-476
 * */
export default {
    dependencies: ['trackingservice'],
    callable(trackingservice) {
        trackingservice.deprecatedTrackEvent('crumbtrail_view');
    },
};



// WEBPACK FOOTER //
// ./controllers/dataTrackView.js